var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01327 1.75853C6.18256 0.0804907 3.20295 0.0804907 1.37224 1.75853C-0.458066 3.43693 -0.458066 6.16769 1.37224 7.8461C3.00254 9.34007 5.54164 9.50012 7.37115 8.33354C7.40965 8.5005 7.49775 8.65983 7.63943 8.7897L10.3055 11.2335C10.694 11.5888 11.3219 11.5888 11.7084 11.2335C12.0965 10.8777 12.0965 10.3022 11.7084 9.94755L9.04232 7.50307C8.90144 7.3743 8.72722 7.29318 8.54506 7.25789C9.81858 5.58058 9.64396 3.25359 8.01327 1.75853ZM7.17153 7.07455C5.80475 8.32735 3.58036 8.32735 2.21398 7.07455C0.847995 5.82176 0.847995 3.78323 2.21398 2.53043C3.58036 1.278 5.80475 1.278 7.17153 2.53043C8.53831 3.78323 8.53831 5.82176 7.17153 7.07455Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9164d883a4f72382103f4dc567ef97a8.svg";
export { ForwardRef as ReactComponent };